<header>
  <!-- Heading -->
  <div class="pt-5 bg-neutral-50 header">
    <div class="container">
      <div class="row">
        <div class="col-4 d-none d-lg-block">
          <div class="mb-2">
            <i class="mr-2 fa fa-phone text-wine-red"></i>03 9419 6990
          </div>
          <div>
            <i class="mr-2 fa fa-envelope-o text-wine-red"></i><span>info@mwwines.com.au</span>
          </div>
        </div>
        <div class="col-xs-12 col-md-7 col-lg-4 text-lg-center text-center mb-4 text-md-right">
          <img src="../assets/images/MW-Wines-Logo-dark.png" alt="mw-wines-logo" class="header-logo">
        </div>
        <div class="col-xs-12 text-center text-md-right col-md-5 col-lg-4">
          <div class="d-flex flex-column">
            <ng-container *ngIf="auctionService.auctionClosing as closing">

              <ng-container *ngIf="closing.available">
                <span class="mb-2">Current auction closing in:</span>
                <span class="text-red mb-2 font-lg font-weight-bold">
                  <span *ngIf="closing.available">
                    {{closing.days}}d : {{closing.hours}}h : {{closing.minutes}}m : {{closing.seconds}}s
                  </span>
                </span>
              </ng-container>

              <ng-container *ngIf="!closing.available && closing.isOpenStatus">
                <span class="mb-2">Next auction opens:</span>
                <span class="text-red mb-2 font-lg font-weight-bold">
                  {{closing.nextOpenDate|date:'d MMMM yyyy h:mmaa'}}
                </span>
              </ng-container>

              <ng-container *ngIf="!closing.available && !closing.isOpenStatus">
                <span class="mb-2">Next auction opens:</span>
                <span class="text-red mb-2 font-lg font-weight-bold">
                  {{closing.nextOpenDate|date:'d MMMM yyyy HH:mm'}}
                </span>
              </ng-container>

            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Heading -->

  <!-- Navbar -->
  <nav class="navbar navbar-expand-lg bg-neutral-50 sticky-top pt-2 pb-4">
    <div class="container">
      <button id="navToggle" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <i class="fa fa-2x fa-bars"></i>
        <!-- <span class="navbar-toggler-icon"></span> -->
      </button>

      <div class="navbar-collapse collapse" id="navbarSupportedContent">
        <ul class="navbar-nav font-md">
          <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
            <a class="nav-link" [routerLink]="['/']">Home</a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" [routerLink]="['/auction']">Auction Search</a>
          </li>
          <!-- <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" [routerLink]="['/auction/manage-filters']">My Auction Filters</a>
          </li> -->
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" [routerLink]="['/bids']">Watch & Bid List</a>
          </li>
          <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
            <a class="nav-link" [routerLink]="['/sell']">Selling</a>
          </li>
          <li class="nav-item dropdown" routerLinkActive="active">
            <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">About</a>
            <div class="dropdown-menu">
              <a class="dropdown-item" [routerLink]="['/about/history']">History</a>
              <a class="dropdown-item" [routerLink]="['/about/staff']">Staff</a>
              <a class="dropdown-item" [routerLink]="['/about/terms-conditions']">Terms and Conditions</a>
            </div>
          </li>
          <!-- <li class="nav-item" *ngIf="loggedIn" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
            <a class="nav-link" [routerLink]="['/account']">
              Account
            </a>
          </li> -->
        </ul>
        <!-- Not Logged In -->
        <ul class="navbar-nav ml-auto" *ngIf="!loggedIn">
          <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
            <a class="nav-link" [routerLink]="['/login']" [state]="{ redirect: router.url }">
              Login
            </a>
          </li>
          <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
            <a class="nav-link text-red" [routerLink]="['/register']" [state]="{ redirect: router.url }">
              Register
            </a>
          </li>
        </ul>
        <!-- /Not Logged In -->

        <!-- LOGGED IN -->
        <ul class="navbar-nav ml-auto" *ngIf="loggedIn">
          <li class="nav-item dropdown" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
            <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">{{currentUser.FirstName}} {{currentUser.Surname || currentUser.LastName}}</a>
            <div class="dropdown-menu">
              <a class="dropdown-item" [routerLink]="['/account']">My account</a>
              <a class="dropdown-item" [routerLink]="['/invoices']">My invoices</a>
              <a class="dropdown-item" [routerLink]="['/remittances']">My remittances</a>
              <a class="dropdown-item" [routerLink]="['/change-password']">Change password</a>
              <div class="dropdown-divider"></div>
              <a href="javascript:void(0)" (click)="logout()" class="dropdown-item">Logout</a>
            </div>

            <!-- <span class="nav-link" (click)="logout()">
              {{currentUser.FirstName}} {{currentUser.Surname || currentUser.LastName}}
            </span> -->
            <!-- <small><a href="javascript:void(0)" (click)="logout()">logout</a></small> -->
          </li>

        </ul>
        <!-- /LOGGED IN -->

      </div>
    </div>
  </nav>
  <!-- /Navbar -->
</header>

<!-- Content -->
<div class="bg-neutral-25">
  <router-outlet></router-outlet>
</div>
<!-- <div class="container bg-white" style="margin-top:-75px; min-height:750px;">
  
</div> -->
<!-- /Content -->

<!-- Footer -->
<div class="bg-neutral-50 pt-5 pb-2 footer font-nephilm">
  <div class="container">
    <div class="row">
      <div class="col-xs-12 col-md-3 text-center text-md-left">
        <img src="../assets/images/MW-Wines-Logo-dark.png" alt="MW-Wines-Logo" style="width: 80px;" class="mb-5">
        <div class="d-flex flex-column mb-4">
          <h5 class="text-red">
            Social Media
          </h5>
          <div>
            <!-- <i class="fa fa-facebook mr-4"></i>
            <i class="fa fa-twitter mr-4"></i> -->
            <i class="fa fa-instagram mr-4"></i>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-3 text-center text-md-left">
        <h5 class="text-red">Museum Wine Shop</h5>
        <ul class="p-0">
          <li>Home</li>
          <li>Wine Resources</li>
          <li>FAQ</li>
          <li>Trade Enquiries</li>
        </ul>
      </div>
      <div class="col-xs-12 col-md-3 text-center text-md-left">
        <h5 class="text-red">Museum Wine Shop</h5>
        <ul class="p-0">
          <li>Home</li>
          <li>Wine Resources</li>
          <li>FAQ</li>
          <li>Trade Enquiries</li>
        </ul>
      </div>
      <div class="col-xs-12 col-md-3 text-center text-md-left">
        <h5 class="text-red">Museum Wine Shop</h5>
        <ul class="p-0">
          <li>Home</li>
          <li>Wine Resources</li>
          <li>FAQ</li>
          <li>Trade Enquiries</li>
        </ul>
      </div>
      <div class="col-12 mt-5 text-center">
        Copyright
      </div>
      <!-- <div class="col-6 text-right">
        <span class="mr-3">Version: {{appVersion}}</span><span>Page Reference: {{pageRef}}</span>
      </div> -->
    </div>
  </div>
</div>
<!-- /Footer -->
